import React from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const SecurityCloseAccountForGa = (props) => {
    const onClickHandler = (e) => {
        e.preventDefault();
        props.toggleModal(false, null);
        return function (isToggleChat) {
            if (isToggleChat) {
                props.toggleChat(isToggleChat);
            }
        };
    };
    return (
        <ModalComponent canCloseModal={false} isVerticalCentered>
            <InfoPage
                insideModalComponent
                animatedIconFail
                mainText={
                    <>
                        <span className="color-GT">{props.deactivateDialogViolet}</span>
                        {` ${props.deactivateDialogTitle}`}
                    </>
                }
                topButtonCaption={props.notNowButton}
                topButtonOnClick={(e) => onClickHandler(e)(false)}
                primaryButtonCaption={props.chat}
                primaryButtonOnClick={(e) => onClickHandler(e)(true)}
            />
        </ModalComponent>
    );
};
const mapStateToProps = (state) => {
    return {
        chat: state.messages.pageMessages.chat,
        notNowButton: state.messages.pageMessages.notNowButton,
        deactivateDialogTitle: state.messages.pageMessages.deactivateDialogTitle,
        deactivateDialogViolet: state.messages.pageMessages.deactivateDialogViolet,
    };
};
export default connect(mapStateToProps, { toggleModal, toggleChat })(SecurityCloseAccountForGa);
